const ADMIN_DEBUG_COMPANY_PREFIX = "__ADMIN_WATCH_COMPANY__";

export function isFromAdmin() {
    const fromAdmin = new URLSearchParams(location.search).get("fromAdmin");

    if (fromAdmin) {
        localStorage.setItem(`${ADMIN_DEBUG_COMPANY_PREFIX}`, "1");

        return true;
    }

    return !!localStorage.getItem(`${ADMIN_DEBUG_COMPANY_PREFIX}`);
}
